var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal",
      attrs: {
        id: _vm.modalId,
        tabindex: "-1",
        role: "dialog",
        "aria-hidden": "true",
        "data-keyboard": "false",
        "data-backdrop": "static"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog ", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            {
              staticClass: "modal-header",
              staticStyle: { "border-bottom": "none" }
            },
            [
              _c("h5", { staticClass: "modal-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("message.areyousuretoclonethisdocument")) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              !_vm.loading
                ? _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: { click: _vm.onClose }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          !_vm.loading
            ? _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-light",
                    attrs: { type: "button" },
                    on: { click: _vm.onCancel }
                  },
                  [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-web",
                    attrs: { type: "button" },
                    on: { click: _vm.onConfirm }
                  },
                  [_vm._v(_vm._s(_vm.$t("button.clone")))]
                )
              ])
            : _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-light",
                    attrs: { type: "button", disabled: "" }
                  },
                  [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                ),
                _vm._v(" "),
                _vm._m(0)
              ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9dbd57de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9dbd57de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseConfirmCloneModal.vue
// module id = null
// module chunks = 